// Shared admin-tab helpers — exported so AdminPage and any extracted
// tab component (AuditLogTab, etc.) consume the same role-badge map
// and duration formatter without duplication.

export const ROLE_BADGES = {
  super_admin: { label: 'Super Admin', className: 'bg-purple-100 text-purple-700' },
  cco: { label: 'CCO', className: 'bg-rose-100 text-rose-700' },
  cro: { label: 'CRO', className: 'bg-amber-100 text-amber-700' },
  admin: { label: 'Sales', className: 'bg-blue-100 text-blue-700' },
  cs: { label: 'CS', className: 'bg-teal-100 text-teal-700' },
  user: { label: 'User', className: 'bg-slate-100 text-slate-700' },
};

export function formatDuration(secs) {
  if (secs == null) return 'Active';
  const m = Math.floor(secs / 60);
  const s = secs % 60;
  const h = Math.floor(m / 60);
  const rm = m % 60;
  if (h > 0) return `${h}h ${rm}m`;
  if (m > 0) return `${rm}m ${s}s`;
  return `${s}s`;
}
